import { FacetCountsDTO, MappedFacetCounts } from "./filters.type";
import { mapFacetCounts } from "./mapFacetCounts";
import getEnvironment from "../getEnvironment";

const getFacetCounts = async (
  url: string,
  currentFacet: string,
  authToken: string,
  isToUseAuthZero: boolean
): Promise<MappedFacetCounts> => {
  let headers: HeadersInit = {
    "Content-Type": "application/json",
  };

  if (getEnvironment() === "localhost") {
    if (!process.env.TOKEN) {
      console.log("TOKEN variable not set.");
    }

    headers = { ...headers, Authorization: `Bearer ${process.env.TOKEN}` };
  }

  if (isToUseAuthZero) {
    headers = {
      ...headers,
      Authorization: `Bearer ${authToken}`,
    };
  }

  const res = await fetch(url, {
    method: "GET",
    headers,
  });

  if (!res.ok) {
    throw new Error(
      `An error (${res.status}) occurred while fetching the data.`
    );
  }
  const result: FacetCountsDTO = await res.json();
  return mapFacetCounts(result);
};

export default getFacetCounts;
